import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModaleResetPasswordSuccessComponent } from '../../modali/modale-reset-password-success/modale-reset-password-success.component';

@Component({
	selector: 'app-reset-password',
	imports: [FormsModule],
	templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent {
	router = inject(Router);
	authService = inject(AuthService);
	activatedRoute = inject(ActivatedRoute);
	modalService = inject(NgbModal);

	nuovaPassword = signal('');
	confermaNuovaPassword = signal('');
	showNew = signal(false);
	showConfirm = signal(false);
	loading = signal(false);
	error = signal(false);
	errorMsg = signal('');

	cambia() {
		this.error.set(false);

		const token = this.activatedRoute.snapshot.queryParamMap.get('token');
		if (!token) {
			this.error.set(true);
			this.errorMsg.set('Token non trovato');
			return;
		}

		if (!this.nuovaPassword() || !this.confermaNuovaPassword()) {
			this.error.set(true);
			this.errorMsg.set('Tutti i campi sono obbligatori.');
			return;
		}

		if (this.nuovaPassword() !== this.confermaNuovaPassword()) {
			this.error.set(true);
			this.errorMsg.set('Le password non coincidono.');
			return;
		}

		this.loading.set(true);

		this.authService.updatePassword(token, this.nuovaPassword(), this.confermaNuovaPassword()).subscribe({
			next: (updated) => {
				this.loading.set(false);
				const modalRef = this.modalService.open(ModaleResetPasswordSuccessComponent, { centered: true });
				modalRef.result.then(
					() => {
						this.goBack();
					},
					() => {
						this.goBack();
					},
				);
			},
			error: (err) => {
				this.loading.set(false);
				this.error.set(true);
				if (err.status === 409) {
					this.errorMsg.set('Il link per il recupero della password è scaduto o è già stato utilizzato.');
				} else {
					this.errorMsg.set(err.error || 'Si è verificato un errore. Riprova.');
				}
			},
		});
	}

	goBack() {
		const isWeb = this.router.url.includes('/web/');
		this.router.navigate([isWeb ? '/web/public/login' : '/app/public/login']);
	}

	checkPassword(password: string) {
		this.error.set(!this.validatePassword(password));
		if (this.error()) {
			this.errorMsg.set('La password non è abbastanza forte');
		}
	}

	validatePassword(password: string): boolean {
		if (!password || password.length < 8) return false;

		const hasSpecial = /[^A-Za-z0-9]/.test(password); // carattere speciale
		if (!hasSpecial) return false;

		const rules = [
			/[A-Z]/.test(password), // maiuscola
			/[a-z]/.test(password), // minuscola
			/[0-9]/.test(password), // numero
			hasSpecial, // carattere speciale
		];

		const passedRules = rules.filter((r) => r).length;

		return passedRules >= 3;
	}
}
